/**
 * API 基础路径常量配置
 */

/**
 * API v1 业务接口基础路径
 * 适用于：/auth, /cloud, /history, /trash, /claim, /share-group, /profile 等
 */
export const API_BASE_URL = '/api/v1'

/**
 * API 根路径
 * 适用于：/upload, /download 等非 v1 分组接口
 */
export const API_ROOT_URL = '/api'
